// Copyright 2025, Imprivata, Inc.  All rights reserved.

import { withRole } from '@common/authorization/Roles';
import { useTranslation } from 'react-i18next';
import { ROLE_TYPE_ADMIN } from '../../constants';
import { SETTINGS_TAB_KEYS, SETTINGS_TABS, type SettingsTab } from './SettingsTabs';
import './Settings.less';

type SettingsProps = { activeTab?: SettingsTab };

export const Settings = ({ activeTab = SETTINGS_TAB_KEYS.users }: SettingsProps) => {
  const { t } = useTranslation();

  const activeTabConfig = SETTINGS_TABS.find(tab => tab.key === activeTab) ?? SETTINGS_TABS[0];

  const ActiveComponent = activeTabConfig.component;

  return (
    <div className="settings-container">
      <div className="settings-header">
        <div className="settings-header-left">
          <h1>{t(activeTabConfig.titleKey)}</h1>
          {activeTabConfig.descriptionKey && (
            <p className="settings-description">{t(activeTabConfig.descriptionKey)}</p>
          )}
        </div>
      </div>

      <div className="settings-content">
        <ActiveComponent key={activeTab} />
      </div>
    </div>
  );
};

export default withRole({ authorizedRoles: [ROLE_TYPE_ADMIN] })(Settings);
